export default __webpack_public_path__ + "static/media/cough.09d73081.png";